import {Button} from '_core'
import {
  completeOrderEdit,
  selectIsCompliantFetch,
  selectOrderEditIsSubmitting,
  setOrderErrors,
} from 'app/features/orders/redux/order/orderEditSlice'
import React, {useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {RootState} from 'setup'

interface Props {
  title?: string
  disabled?: boolean
  onBeforeComplete?: () => any
  shippingRate?: any
  showLoader?: boolean
  loaderText?: string
}

export const PaymentProcessButton: React.FC<Props> = ({
  title = 'Process Payment',
  disabled,
  onBeforeComplete,
  shippingRate,
  showLoader,
  loaderText,
}) => {
  const dispatch = useDispatch()
  const isSubmitting = useSelector<RootState, boolean>(selectOrderEditIsSubmitting)
  const isTaxCalculating = useSelector<RootState, boolean>(selectIsCompliantFetch)

  const history = useNavigate()

  useEffect(() => {
    return () => {
      dispatch(setOrderErrors([]))
    }
  }, [dispatch])

  const handleSubmit = async () => {
    dispatch(setOrderErrors([]))
    if (onBeforeComplete) {
      if (await onBeforeComplete()) {
        dispatch(completeOrderEdit(history, shippingRate))
      }
    } else {
      dispatch(completeOrderEdit(history, shippingRate))
    }
  }

  const loText = useMemo(() => {
    if (showLoader && loaderText) {
      return loaderText
    }
    if (isTaxCalculating) {
      return 'Calculating Tax'
    }
    return 'Please wait'
  }, [isTaxCalculating, loaderText, showLoader])

  return (
    <Button
      id='btnPay'
      title={title}
      className='btn btn-primary-active w-100'
      isSubmitting={isSubmitting || showLoader}
      onClick={handleSubmit}
      disabled={disabled || isTaxCalculating}
      loaderText={loText}
    />
  )
}

export default PaymentProcessButton
